// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab } from "../../../BundleResourceConfig";
import { backpackOpenType } from "../../../config/backpackConst";
import { NormalBackpackI } from "../../../manager/DefineInterface";
import NormalGameManager from "../../../manager/NormalGameManager";
import UserDataManage from "../../../model/UserDataManage";
import BackpackPrefab from "../../backpack/BackpackPrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MilitaryMyOfficerItem extends BaseComponent {

	@property({ type: cc.Label, displayName:'' })
	labelGassisonAddAni: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelPos: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodePos: cc.Node = null;

	@property({ type: cc.Button, displayName:'' })
	btnDrop: cc.Button = null;

    @property({ type: cc.Label, displayName:'' })
	labelEarningAdd: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelEarning: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelGassisonAdd: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelGarrison: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelExclusiveCity: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprHead: cc.Sprite = null;

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;

  
	private officerId: string = null;
	private csvInfo: any = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
		this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.OFFICER, this.officerId);
		if (!this.csvInfo) {
			console.error('未找到武将数据 officerId = ', this.officerId);
		}
		this.initUI();
    }

	setData(
        officerId: string
    ) {
        this.officerId = officerId;
    }

	initUI() {
		this.labelName.string = this.csvInfo.name;
		this.labelGassisonAddAni.node.active = false;

		this.refreshEarning();
		this.refreshGassison();
		this.refreshHead();
		this.refreshExclusiveCity();
	}

	refreshEarning() {
		let eraning_promote = Number(this.csvInfo.eraning_promote);
		let exclusive_eraning_promote = Number(this.csvInfo.exclusive_eraning_promote);
		this.labelEarning.string = Math.floor(eraning_promote * 100) + '%';
		this.labelEarningAdd.string = ' +' + Math.floor((exclusive_eraning_promote - eraning_promote) * 100) + '%';
	}

	refreshGassison() {
        let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
        let militaryOfficerData = militaryOfficerDataManage.militaryOfficerData;
        let data = militaryOfficerData.lists.get(this.officerId);
        
		let normalGassison = Number(this.csvInfo.garrison);
		let exclusive_garrison = Number(this.csvInfo.exclusive_garrison);
        let eAdd = Math.floor((exclusive_garrison - normalGassison) * 100);
        normalGassison += data.addGarrison;

        let gv = (normalGassison * 100).toFixed(1);
		this.labelGarrison.string = gv + '%';
		this.labelGassisonAdd.string = ' +' + eAdd + '%';


		if (utilsModel.isValidNumberValue(data.curGarrisonCity)) {
			let cityCsv = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.CITY, data.curGarrisonCity);
			if (!cityCsv) {
				console.error('未找到城池数据 curGarrisonCity = ', data.curGarrisonCity);
				return;
			}
			this.btnDrop.interactable = false;
			this.nodePos.active = true;

			this.labelPos.string = cityCsv.name;
		} else {
			this.btnDrop.interactable = true;
			this.nodePos.active = false;
		}
		
		
	}

	refreshExclusiveCity() {
		let exclusive_city = this.csvInfo.exclusive_city;
		let cityCsv = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.CITY, exclusive_city);
		if (!cityCsv) {
			this.labelExclusiveCity.string = '';
			console.error('未找到城池数据 exclusive_city = ', exclusive_city);
			return;
		}

		this.labelExclusiveCity.string = cityCsv.name;
	}

	refreshHead() {
		this.sprHead.node.active = false;
        if (utilsModel.isValidNumberValue(this.csvInfo.icon)) {
            let iconPath = "res/recruit/head/" + this.csvInfo.icon;
            getOneBundleByInstant(BUNDLE_SMALL_NAME.militaryBundle).load(iconPath, cc.SpriteFrame
                , (err,imgs:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log(err);
                    }else{
                        this.sprHead.node.active = true;
                        this.sprHead.spriteFrame = imgs;
                    }
                }
            );
        }
	}

	onClickDrop() {
		O1HD.getManagers().soundMgr.playSound("anNiu").then();

		let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
        let militaryOfficerData = militaryOfficerDataManage.militaryOfficerData;
		let lists = militaryOfficerData.lists;
		lists.delete(this.officerId);

		militaryOfficerData.saveLocalData();
		this.destroyNode();
	}

    promoteGarrison(v: number) {
        let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
        let militaryOfficerData = militaryOfficerDataManage.militaryOfficerData;
        let data = militaryOfficerData.lists.get(this.officerId);
        data.addGarrison += v;
        militaryOfficerData.saveLocalData();
        this.refreshGassison();


		let nodeItem = cc.instantiate(this.labelGassisonAddAni.node);
        nodeItem.active = true;
        nodeItem.parent = this.labelGassisonAddAni.node.parent;
        let label = nodeItem.getComponent(cc.Label);
        label.string = '   +' + (v*100).toFixed(1) + '%';

		let tm = 0.25;
        cc.tween(nodeItem)
        .delay(0.5)
        .parallel(
            cc.tween(nodeItem).to(tm, {opacity: 50})
            , cc.tween(nodeItem).to(tm, {y: 20})
        )
        .removeSelf()
        .start();
    }
    
    onClickSendGoods() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        new Promise<void>(async aresolve=>{
            let url = "backpack/backpackPrefab";
            let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.backPackGameBundle,url);
            if(prefab){
                let backpack = cc.instantiate(prefab);
                backpack.getComponent(BackpackPrefab).bindData(backpackOpenType.select,null,(item:NormalBackpackI)=>{
                    NormalGameManager._instance.onOutGoods(item.id,1);
                    if (utilsModel.isValidNumberValue(item.promoteGarrison)) {
                        this.promoteGarrison(item.promoteGarrison);
                    }
					O1HD.getModules().uiControlModule.showMessageBox("赠送成功");
                    aresolve();
                });
                O1HD.Canvas().addChild(backpack);
            }
        });
    }
}
